var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03563 3.0375C-0.011875 5.085 -0.011875 8.415 2.03563 10.4625C3.06313 11.49 4.40563 12 5.74813 12C7.09063 12 8.43313 11.49 9.46062 10.4625C12.0706 7.8525 12.4981 0 12.4981 0C12.4981 0 4.64563 0.4275 2.03563 3.0375ZM8.40313 9.405C7.69063 10.11 6.75313 10.5 5.74813 10.5C5.08063 10.5 4.45063 10.3125 3.88813 9.99C4.57813 7.83 5.85312 5.9325 7.54812 4.5C5.57562 5.52 3.91813 7.095 2.77063 9C1.66063 7.53 1.75812 5.4375 3.10063 4.095C4.40563 2.79 8.02812 1.9875 10.8481 1.65C10.5106 4.47 9.70813 8.0925 8.40313 9.405Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentor);
export default __webpack_public_path__ + "static/media/mentor.730aee1ec71bf1a8b8c43d209a2983fc.svg";
export { ForwardRef as ReactComponent };